import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(() => ({
  root: {
    padding: '15px',
    marginBottom: '10px',
    borderBottom: '2px solid #ccc',
    width: '100%'
  },
  icon: {
    color: '#7647B2',
    transform: 'scale(1.5, 1.5)',
    width: 22,
    height: 22
  }
}))
